import { Github, Twitter, Edit } from 'lucide-react'

export default function HeroSection() {
  return (
    <div className="mb-8 sm:mb-12">
      <div className="flex items-start justify-between w-full max-w-xs mx-auto">
        {/* Left: Profile Image */}
        <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full overflow-hidden border-2 border-white/20 flex-shrink-0 bg-white">
          <img 
            src="/me.PNG" 
            alt="川端 和樹" 
            className="w-full h-full object-cover opacity-100"
          />
        </div>
        
        {/* Right: Name, Role, Social Links */}
        <div className="flex-1 ml-4 sm:ml-6">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-1 sm:mb-2">
            川端 和樹
          </h1>
          <p className="text-base sm:text-lg text-gray-300 mb-3 sm:mb-4">
            BizDevエンジニア
          </p>
          <div className="flex space-x-3 sm:space-x-4">
            <a 
              href="https://github.com/c4b1" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors p-1.5 sm:p-2 rounded-lg hover:bg-white/10"
            >
              <Github size={18} className="sm:w-5 sm:h-5" />
            </a>
            <a 
              href="https://x.com/hashcray" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors p-1.5 sm:p-2 rounded-lg hover:bg-white/10"
            >
              <Twitter size={18} className="sm:w-5 sm:h-5" />
            </a>
            <a 
              href="https://note.com/c4b1" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors p-1.5 sm:p-2 rounded-lg hover:bg-white/10"
            >
              <Edit size={18} className="sm:w-5 sm:h-5" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}